<template>
  <div class="columns is-multiline is-variable is-mobile is-5">
    <div class="column" :class="columnClasses" v-for="result in reviewResults" :key="result.id">
      <div class="grid-box">
        <div>{{ result.getLabel() }}:
          <span><strong>{{ result.getValue() }}</strong></span>
          <review-customer-actions-component
            :result="result"
            v-on:showFinding="$emit('showFinding', result)">
          </review-customer-actions-component>
          <div class="dependencies" v-for="(dependency, key) in result.dependencies" :key="key">
            <div>{{ dependency.label }}:
              <span><strong>{{ dependency.value }}</strong></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import ReviewCustomerActionsComponent from '@/components/layout/ReviewCustomerActionsComponent'

  export default {
    name: 'review-customer-exam-component',
    components: { ReviewCustomerActionsComponent },
    props: {
      reviewResults: {
        type: Array,
        required: true
      },
      columnClasses: {
        type: String,
        default: 'is-6-mobile is-4-tablet is-3-desktop'
      }
    }
  }
</script>
<style lang="sass" scoped>
  .dependencies
    padding: 1rem 0 0 1rem
</style>
